import React, { FunctionComponent } from 'react';

export const MobileDownloadIcon: FunctionComponent<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" width={80} height={80} {...props}>
    <path
      d="M368,512H144c-17.6,0-32-14.4-32-32V32c0-17.6,14.4-32,32-32h224c17.6,0,32,14.4,32,32v448C400,497.6,385.6,512,368,512z"
      fill="#333333"
    />
    <rect x="135.456" y="50.672" width="241.28" height="372" fill="#c9c9c9" />
    <path
      d="M256.176,489.456c-12.496,0-22.656-10.176-22.656-22.672s10.16-22.672,22.656-22.672s22.672,10.176,22.672,22.672S268.672,489.456,256.176,489.456z M256.176,452.112c-8.08,0-14.656,6.576-14.656,14.672s6.576,14.672,14.656,14.672c8.096,0,14.672-6.576,14.672-14.672S264.272,452.112,256.176,452.112z"
      fill="#ffffff"
    />
    <circle cx="256.16" cy="25.328" r="7.792" fill="#ffffff" />
    <circle cx="312.816" cy="25.328" r="7.792" fill="#ffffff" />
    <circle cx="337.44" cy="25.328" r="7.792" fill="#ffffff" />
    <rect x="248" y="134.144" width="16" height="106.08" fill="#333333" />
    <polygon points="212.528,238.624 256,301.008 299.472,238.624" fill="#2c2a2a" />
    <polygon
      points="330.176,347.6 181.824,347.6 181.824,293.904 197.824,293.904 197.824,331.6 314.176,331.6 314.176,293.904 330.176,293.904"
      fill="#2c2a2a"
    />
  </svg>
);
